<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import { dateFormat } from "@/utils/helpers/format";
import Table from "@/components/standard/PrevencionEmergencias/components/PromotionTable";
import prevencionEmergenciasAPI from "@/services/standards/prevencionEmergencias/prevencionEmergenciasAPI.js";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import ItemAPI from "@/services/items/itemsAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import PromotionPagination from "../../../components/standard/PrevencionEmergencias/components/PromotionPagination.vue";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "5.1.1 Plan de prevención, preparación y respuesta ante emergencias",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
    PromotionPagination
  },
  data() {
    return {
      title: "5.1.1 Plan de prevención, preparación y respuesta ante emergencias",

      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "5.1.1 Plan de prevención, preparación y respuesta ante emergencias",
          active: true,
        },
      ],
      lista: [],

      item: null,
      itemStatus: "No cumplido",
      loading: true,
      search: "",
      deleteCount: 0,
      itemData: null,
      file: null,
      lastId: 1,
      program: {
        file: "datos",
        start_emergency_date: null,
        end_emergency_date: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      submitted: false,
      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  validations: {
    program: {
      start_emergency_date: {
        required,
      },
      end_emergency_date: {
        required,
      },
      file: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(51)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page
    },

    goBack() {
      this.$router.go(-1);
    },

    fetch() {
      this.$refs.paginator.query();
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 51)
        .then(response => {
          this.item = response || null
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch(error => {
          console.log(error)
        })
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 51,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            style: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            style: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    deletePrevencion(id) {
      prevencionEmergenciasAPI.delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 51,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se ha sido eliminado con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    async print() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/formato/Guía elaboración Plan de emergencias.xlsx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/5.1.1/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/5.1.1/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.program.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getList() {
      prevencionEmergenciasAPI.getprevencion(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          let identification = response.data.data;
          this.lista = identification
          if (response.data.data[0]['id']) {
            this.lastId = response.data.data[0]['id'] + 1
          }
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    async save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.submitted = true;
        this.loading = true
        let response = await this.uploadDocument();
        if (response) {
          const data = {
            start_emergency_date: this.program.start_emergency_date,
            end_emergency_date: this.program.end_emergency_date,
            file: this.program.file,
            companies_id: this.companyID,
          };
          prevencionEmergenciasAPI.save(data)
            .then((response) => {
              const itemChange = {
                companies_id: this.companyID,
                item_id: 51,
                status: 'Pendiente',
              };
              newScoresAPI.calculateScores(itemChange)
                .then((response) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Se ha registrado con éxito!",
                      type: "success",
                      icon: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                  }, 2000);
                  window.location.reload();
                })
                .catch((error) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "Error",
                      text: "¡No se ha podido registrar!",
                      icon: "error",
                      type: "error",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 1000);
                  console.log(error);
                });
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.loading = false
          setTimeout(() => {
            Swal.fire({
              title: "¡Error!",
              text: "¡No se ha podido registrar!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }, 2000)
        }
      }
    },
  },
  mounted() {
    this.getItems();
    this.getItemData();
    this.getList();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <CheckModal>
                    <p class="text-justify">
                      Se debe contar con un plan de prevención, preparación y respuesta ante emergencias y programar su
                      divulgación en el ítem 1.2.1.
                    </p>
                    <p class="text-justify">
                      Contar con los planos de las instalaciones que identifican áreas y salidas de emergencia y
                      verificar si existe la debida señalización de la empresa.
                    </p>
                    <p class="text-justify">
                      Subir los soportes que evidencien la realización de los simulacros y análisis de los mismos y
                      validar que las recomendaciones emitidas con base en dicho análisis hayan sido tenidas en cuenta
                      en el mejoramiento del plan de emergencias.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>

                <div class="col-12 text-right m-b-0">
                  <a @click="print" class="btn btn-outline-primary mx-1" id="tooltip">
                    <i>Guía elaboración Plan de Emergencias</i>
                  </a>
                  <b-tooltip target="tooltip" placement="top">
                    Descargar Guía elaboración Plan de Emergencias
                  </b-tooltip>
                </div>
              </div>

              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12">
                  <b-form-group class="col-md-6 px-2" label="Fecha inicio vigencia Plan de emergencias"
                    label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="trainingDate"
                      v-model="program.start_emergency_date"
                      :class="{ 'is-invalid': $v.program.start_emergency_date.$error && submitted }">
                      >
                    </b-form-input>
                    <div v-if="submitted && $v.program.start_emergency_date.$error">
                      <small v-if="!$v.program.start_emergency_date.required" class="text-danger">
                        <b>La fecha de inicio vigencia Plan de emergencias es requerida</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Fecha fin vigencia Plan de emergencias"
                    label-for="endDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="endDate"
                      v-model="program.end_emergency_date"
                      :class="{ 'is-invalid': $v.program.end_emergency_date.$error && submitted }">
                      >
                    </b-form-input>
                    <div v-if="submitted && $v.program.end_emergency_date.$error">
                      <small v-if="!$v.program.end_emergency_date.required" class="text-danger">
                        <b>La fecha final de la vigencia del Plan de emergencias es requerida</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>
                <b-form-group class="col-md-12 px-2" label="Subir Plan de Emergencias" label-for="file">
                  <b-form-file required :disabled="!allowAccess() || !getRole('Crear')" type="file" id="file" ref="file"
                    name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                    drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                    accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                  </b-form-file>
                  <div v-if="submitted && $v.program.file.$error">
                    <small v-if="!$v.program.file.required" class="text-danger">
                      <b>El plan de emergencias es requerido</b>
                    </small>
                  </div>
                </b-form-group>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                </div>
              </form>
              <hr />
              <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                <div class="col-lg-12">
                  <div class="card-body">
                    <div class="row pb-3">
                      <div class="col-6">
                        <form @submit.prevent="fetch()" class="form-inline">
                          <div class="form-group mr-2">

                            <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                              class="form-control px-2" placeholder="Buscar"></b-form-input>

                            <div class="col-1">
                              <button type="submit" class="btn btn-primary px-2">Buscar</button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="col-6"></div>
                    </div>
                    <div class="table-responsive">
                      <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                        <thead class="table-active">
                          <tr>
                            <th class="text-center align-middle">
                              Fecha de inicio
                            </th>
                            <th class="text-center align-middle">
                              Fecha fin
                            </th>
                            <th class="text-center align-middle">
                              Descripcion del archivo
                            </th>
                            <th class="text-center align-middle">
                              Ver archivo
                            </th>
                            <th class="text-center align-middle">
                              Acciones
                            </th>
                          </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                          <tr v-for="item in lista" :key="item.id">
                            <td class="text-center align-middle">
                              {{ dateConvert(item.start_emergency_date) }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dateConvert(item.end_emergency_date) }}
                            </td>
                            <td class="text-center align-middle">
                              Plan de emergencia
                            </td>
                            <td class="text-center align-middle">
                              <div v-if="item.file === null">
                                <h6>No hay archivo disponible
                                </h6>
                              </div>
                              <div v-else>
                                <button :disabled="!allowAccess()"
                                  style=" background-color: transparent !important; border: none;" type="button"
                                  @click="gotoDigitalOcean(`${item.file}`)"> <i class="mdi mdi-cloud-download"></i>
                                </button>
                              </div>
                            </td>
                            <td class="text-center align-middle">
                              <div class="col-sm-12">
                                <b-dropdown variant="primary" :disabled="!allowAccess()">
                                  <template v-slot:button-content>
                                    <i class="mdi mdi-eye"></i>
                                  </template>
                                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')"
                                    :to="{ path: `/forms/estandares/prevencion-emergencias-editar/${item.id}` }">
                                    Editar
                                  </b-dropdown-item>
                                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')"
                                    :to="{ path: `/forms/estandares/prevencion-emergencias-actas/${item.id}` }">
                                    Ver actas
                                  </b-dropdown-item>
                                  <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                                    v-on:click="deletePrevencion(item.id)">Eliminar</b-dropdown-item>
                                </b-dropdown>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <PromotionPagination :companyID="companyID" ref="paginator" :search="search"
                        @fetch="(items) => (lista = items)" />
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
